import React from 'react'
import BeforeAfterProjectLimitsSection from './BeforeAfterProjectLimitsSection'
import ChangePaymentInterval from './ChangePaymentInterval'
import { PaymentInterval, PaymentIntervalType, RecurlyPrice } from './Recurly'
import ReviewTeams from './ReviewTeams'
import SelectTideways6Plans from './SelectTideways6Plans'
import SelectTideways8Plans from './SelectTideways8Plans'
import Summary from './Summary'
import { UpgradeTideways6, UpgradeTideways6Application } from './UpgradeTideways6'
import { TidewaysContext } from '../app/context'
import Router from '../router'

interface Props {
    recurlyPricing: any
    upgrade: UpgradeTideways6
    actionUrl: string
    csrfToken: string
    tidewaysContext?: TidewaysContext
    router?: Router
}
interface State {
    projectSizes: { [key: string]: number }
    newPlan: string
    requests: number
    price: RecurlyPrice | null
    teams: number
    interval: PaymentInterval
}

class UpgradeOrganization extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props)
        this.state = {
            projectSizes: props.upgrade.projectSizes,
            newPlan: props.upgrade.newPlan.replace('_1y', ''),
            requests: props.upgrade.startRequests,
            price: null,
            teams: props.upgrade.teamsCount,
            interval: props.upgrade.currentPlan.endsWith('_1y') ? PaymentInterval.Yearly : PaymentInterval.Monthly,
        }
    }
    public render() {
        const includedTeams = {
            tideways6_starter: 1,
            tideways6_basic: 1,
            tideways6_standard: 1,
            tideways6_pro: 5,
            tideways7_basic: 1,
            tideways7_standard: 1,
            tideways7_pro: 5,
            tideways8_team: 1,
            tideways8_business: 1,
            tideways8_enterprise: 1,
        }

        const newPlan = this.state.interval == PaymentInterval.Yearly ? this.state.newPlan + '_1y' : this.state.newPlan
        const paymentIntervalType = this.state.newPlan.startsWith('tideways8')
            ? PaymentIntervalType.TEN_PERCENT
            : PaymentIntervalType.ELEVEN_FOR_TWELVE

        return (
            <div className="row">
                <div className="col-lg-12">
                    <form className="form-horizontal" method="POST" action={this.props.actionUrl}>
                        <input type="hidden" name="_csrf[billing]" value={this.props.csrfToken} />
                        <input type="hidden" name="requests" value={this.state.requests} />
                        <input type="hidden" name="teams" value={this.state.teams} />

                        <div className="row">
                            <div className="col-lg-6">
                                <h3>Select Plan</h3>
                            </div>
                            <div className="col-lg-6" style={{ textAlign: 'right', marginTop: '20px' }}>
                                <a
                                    target="_blank"
                                    href="https://tideways.com/profiler/pricing?utm_medium=app&utm_source=checkout&utm_campaign=upgrade"
                                    rel="noreferrer"
                                >
                                    More Details on Pricing Page
                                </a>
                            </div>
                        </div>
                        {this.props.upgrade.newPlan.startsWith('tideways8') ? (
                            <SelectTideways8Plans
                                recurlyPricing={this.props.recurlyPricing}
                                upgrade={this.props.upgrade}
                                onPlanChange={plan => this.setState({ newPlan: plan })}
                                onRequestsChange={requests => this.setState({ requests: requests })}
                                selectedPlan={this.state.newPlan}
                                interval={this.state.interval}
                                currency={this.props.upgrade.currency}
                                tidewaysContext={this.props.tidewaysContext}
                                router={this.props.router}
                            />
                        ) : (
                            <SelectTideways6Plans
                                upgrade={this.props.upgrade}
                                onPlanChange={this.onUpdatePlan}
                                selectedPlan={this.state.newPlan}
                                recurlyPricing={this.props.recurlyPricing}
                                interval={this.state.interval}
                                currency={this.props.upgrade.currency}
                            />
                        )}
                        {this.renderProjectReviews()}
                        <div className="row">
                            <div className="col-lg-6">
                                <ReviewTeams
                                    upgrade={this.props.upgrade}
                                    actionUrl={this.props.actionUrl}
                                    onTeamsChange={teams => this.setState({ teams })}
                                    newPlan={this.state.newPlan}
                                />
                            </div>
                            <div className="col-md-6">
                                <h3>How often do you want to be billed?</h3>

                                <ChangePaymentInterval
                                    type={paymentIntervalType}
                                    interval={this.state.interval}
                                    callback={interval => this.setState({ interval })}
                                />
                            </div>
                        </div>
                        <Summary
                            recurlyPricing={this.props.recurlyPricing}
                            upgrade={this.props.upgrade}
                            newPlan={this.state.newPlan}
                            requests={this.state.requests}
                            coupon={this.props.upgrade.coupon}
                            currency={this.props.upgrade.currency}
                            projectSizes={this.state.projectSizes}
                            interval={this.state.interval}
                            teams={this.state.teams}
                        />
                        <input type="hidden" name="plan" data-recurly="plan" value={newPlan} />
                        {this.props.upgrade.applications.map((application, id) => {
                            return (
                                <input
                                    key={application.id}
                                    type="hidden"
                                    name={`projectSizes[${application.id}]`}
                                    value={this.state.projectSizes[application.id]}
                                />
                            )
                        })}
                        <div className="box-footer centered">
                            <button type="submit" id="signup" className="btn btn-primary">
                                Upgrade with obligation to pay
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        )
    }

    private renderProjectReviews() {
        if (this.state.newPlan.startsWith('tideways8')) {
            return null
        }

        return (
            <>
                <h3>2. Review Projects</h3>
                <div className="box">
                    <div className="box-body">
                        {this.props.upgrade.applications.map((application, id) =>
                            this.renderApplication(application, this.props.upgrade.applications.length === 1),
                        )}
                    </div>
                </div>
            </>
        )
    }

    public renderApplication(application: UpgradeTideways6Application, onlyApplication = false) {
        const min = onlyApplication ? 2 : 0
        return (
            <div key={application.id}>
                <h4>Project {application.name}</h4>

                <div className="row">
                    <div className="col-lg-6">
                        <p>
                            The{' '}
                            <a href="https://support.tideways.com/documentation/account-and-billing/billing-and-invoices/project-sizes.html?utm_medium=app&utm_source=upgrade-organization&utm_campaign=project-sizes">
                                selected project size
                            </a>{' '}
                            determines the number of services, environments, transactions and traces per minute. Select project size 0 to
                            convert a project into a profiling space.
                        </p>

                        <div className="form-group">
                            <label className="col-lg-4 control-label" htmlFor="changeProjectSize">
                                Project Size:
                            </label>
                            <div className="col-lg-1 control-label">
                                <span>{this.state.projectSizes[application.id]}</span>
                            </div>
                            <div className="col-lg-7">
                                <input
                                    type="range"
                                    className="form-control"
                                    min={min}
                                    max="25"
                                    value={this.state.projectSizes[application.id]}
                                    onChange={event => {
                                        this.setState({
                                            projectSizes: {
                                                ...this.state.projectSizes,
                                                [String(application.id)]: parseInt(event.currentTarget.value, 10),
                                            },
                                        })
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        {this.state.projectSizes[application.id] > 0 ? (
                            <BeforeAfterProjectLimitsSection
                                onlyAfter={false}
                                upgrade={this.props.upgrade}
                                projectId={String(application.id)}
                                projectSize={this.state.projectSizes[application.id]}
                                plan={this.state.newPlan}
                            />
                        ) : null}
                        {this.state.projectSizes[application.id] === 0 ? (
                            <p>
                                This project is converted into a{' '}
                                <a
                                    href="https://support.tideways.com/documentation/features/tracing-and-timeline-profiler/profiling-spaces.html?utm_medium=app&utm_source=upgrade-organization&utm_campaign=profiling-spaces"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    profiling space
                                </a>{' '}
                                during the upgrade.
                            </p>
                        ) : null}
                    </div>
                </div>
            </div>
        )
    }

    private onUpdatePlan = plan => {
        this.setState({ newPlan: plan })
    }
}

export default UpgradeOrganization
